import {defineStore} from 'pinia';

interface IError{
    message: string;
    code: string;
}

export const useErrorStore = defineStore("errorStore", {
    // state
    state: (): IError => {
        return {
            message: "Internal Server Error",
            code: "E000"
        }
    },
    actions: {
        saveErrorMessageAndCode(message: string, code: string){
            this.message = message
            this.code = code
        }
    }
})